<template>
    {{ title }}
</template>

<script>
export default {
  name: 'BulletinBox',
  props: {
    title: String
  }
}
</script>